import { useTranslation } from '@wix/wix-i18n-config';

import { Page, useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { TLocalesKeys } from '../../../types';
import { assertUnreachable } from '../../../util/guards';

export const useHeaderTitle = (): string => {
  const { t } = useTranslation();
  const currentPage = useCurrentPage();

  return t<TLocalesKeys>(getHeaderTitleKey(currentPage));
};

function getHeaderTitleKey(currentPage: Page): TLocalesKeys {
  switch (currentPage) {
    case Page.Home:
      return 'help_center_header_title_widget_home';
    case Page.Chatbot:
      return 'widget_title';
    case Page.Search:
      return 'help_center_header_title_widget_search';
    case Page.Categories:
    case Page.Category:
    case Page.Article:
      return 'help_center_header_title_widget';
    default:
      assertUnreachable(currentPage);
  }
}
